import(/* webpackMode: "eager" */ "/project/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/project/node_modules/next/dist/client/link.js");
